/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Slick Slider
 * ########################################
 */
$('.slider-rooms').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow:"<i class='fas fa-angle-left slick-prev'></i>",
    nextArrow:"<i class='fas fa-angle-right slick-next'></i>",
});

